import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Box, Divider, Typography } from "@mui/material";
import { useCurrencyCode } from "../../genericComponents/helper-functions/CurrencySymbol";
import CheckIcon from "@mui/icons-material/Check";
import Image from "next/image";

interface ToolTipInformationProps {
  openInfo: any;
  handleClose: any;
  data: any;
}

const ToolTipInformation: React.FC<ToolTipInformationProps> = ({
  openInfo,
  handleClose,
  data,
}) => {
  const currencyCode = useCurrencyCode();
  return (
    <React.Fragment>
      <Dialog
        open={openInfo}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
      >
        <DialogContent
          sx={{
            padding: { xs: "12px", sm: "16px" },
          }}
        >
          <Box>
            <Image
              src={data?.ImageUrl}
              width={2000}
              height={1000}
              style={{
                margin: "auto",
                objectFit: "cover",
                width: "-webkit-fill-available",
                height: "25vh",
                marginBottom: "1rem",
                borderRadius: "0.5rem",
              }}
              alt="Service Image"
            />
          </Box>
          <Box>
            <Typography
              variant="body1"
              sx={{
                color: "black",
                fontWeight: "bold",
                textAlign: "start",
                fontSize: { xs: "14px", sm: "14px" },
              }}
            >
              {data?.serviceName}
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{
                textAlign: "start",
                fontSize: { xs: "14px", sm: "14px" },
              }}
            >
              {data?.subHeading}
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: "1rem",
            }}
          >
            {data?.aboutList?.map((point: string, index: number) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  padding: "0px 0px",
                }}
              >
                <CheckIcon
                  sx={{
                    color: "green",
                    marginRight: "8px",
                    fontSize: "16px",
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    color: "black",
                    textAlign: "start",
                    fontSize: { xs: "14px", sm: "14px" },
                  }}
                >
                  {point}
                </Typography>
              </Box>
            ))}
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
              marginTop: "1rem",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: "#000",
                fontWeight: "bold",
                textAlign: "start",
                fontSize: { xs: "14px", sm: "14px" },
              }}
            >
              {currencyCode}
              {data?.totalAmount}
            </Typography>
            &nbsp; &nbsp;
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{
                fontSize: { xs: "14px", sm: "14px" },
                textDecoration: "line-through",
              }}
            >
              {currencyCode}
              {data?.totalMrp}
            </Typography>
            &nbsp; &nbsp;
            <Typography
              variant="body1"
              sx={{
                color: "#15741a",
                fontWeight: "bold",
                textAlign: "start",
                fontSize: { xs: "14px", sm: "14px" },
              }}
            >
              Save &nbsp;
              {currencyCode}
              {data?.totalDiscount}
            </Typography>
          </Box>
          {data?.specialPrice && (
            <Box
              sx={{
                display: "block",
                justifyContent: "start",
                alignItems: "center",
                marginTop: "0.5rem",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  color: "#000",
                  fontWeight: "bold",
                  textAlign: "start",
                  fontSize: { xs: "14px", sm: "14px" },
                }}
              >
                Special Price: {currencyCode}
                {data?.specialPrice}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#15741a",
                  textAlign: "start",
                  fontSize: { xs: "14px", sm: "14px" },
                }}
              >
                {data?.specialMessage}
              </Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default ToolTipInformation;
